import React from 'react'
import { useZocksQuota } from '../../../../../components/ScopedBlock/hooks'

const SHAREPOINT_HOW_IT_WORKS_BASE = [
  'Link a SharePoint folder to any client in Zocks',
  'Save generated PDFs - meeting summaries, meeting prep, forms - straight to SharePoint',
  'Keep client documents organized across both platforms',
  'Browse and upload files from SharePoint directly in Zocks',
]

const SHAREPOINT_HOW_IT_WORKS_ULTIMATE = [
  'Pull documents from SharePoint into Zocks for processing - no manual uploads needed',
  'Save document summaries to SharePoint',
  'Work from your existing SharePoint library without leaving the platform',
]

export const SharePointHowItWorks: React.FC = () => {
  const { hasQuota } = useZocksQuota()
  const documentIntelligenceEnabled = hasQuota('ai.documentSummaryAgent.value')
  const lines = documentIntelligenceEnabled ? [...SHAREPOINT_HOW_IT_WORKS_BASE, ...SHAREPOINT_HOW_IT_WORKS_ULTIMATE] : SHAREPOINT_HOW_IT_WORKS_BASE

  return (
    <div>
      <ul>
        {lines.map((line, i) => (
          <li key={i}>{line}</li>
        ))}
      </ul>
    </div>
  )
}
